import { studentBirthdayColumn } from 'Src/components/StudentBirthday/StudentBirthday';
import * as React from 'react';
import BPromise from 'bluebird';
import Lazy from 'lazy.js';
import propz from 'propz';
import { Component } from 'react';
import { History, Location } from 'history';
import { parse } from 'query-string';
import { TwoPanelEditor } from 'Src/components/TwoPanelEditor/TwoPanelEditor';
import { Loader } from 'Src/components/Loader/Loader';
import { DEFAULT_LIMIT, FILTER_TYPE } from 'Src/consts/table';
import { AGE_GROUPS } from 'Src/consts/school';
import { getTwoPanelEditorFilters } from 'Src/helpers/twoPanelEditor/twoPanelEditor';
import { DATE_INTERVAL, LIMIT } from 'Src/consts/table';
import {
  ColumnDefinition,
  getOrder,
  getServerFieldSectionWhere,
  isFilterExist2,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { getTournament } from 'Src/helpers/service/adminSU/tournamentsTable';
import { AppUser } from 'Src/views/App/App';
import {
  getAllSchoolTournamentTeamPlayers,
  getSchoolTournamentTeam,
  SchoolTournamentTeamPlayersBatchData,
  updateSchoolTournamentTeamPlayersBatch
} from 'Src/helpers/service/admin/tournamentTeamPlayers';
import {
  addSchoolUnionSchoolStudent,
  updateSchoolUnionSchoolStudent,
  getAllSchoolUnionSchoolForms
} from 'Src/helpers/service/adminSU/schoolStudentsTable';
import { SchoolForm } from 'Src/models/form';
import { getGender, getAge, getTeamGender } from 'Src/helpers/accessor/accessor';
import { formatTournamentAges } from 'Src/helpers/ageGroups';
import { getSelectOptionForAge, getSelectOptionForGender } from 'Src/helpers/table/select';
import { getUserGenderArrayConvertedFromEventGender } from 'Src/helpers/tournament/tournament';
import { TournamentTeamPlayer } from 'Src/models/tournamentTeamPlayer';
import { getSchoolStudentsList, searchSchoolStudents } from 'Src/helpers/service/adminSU/schoolTeamPlayers';
import { SchoolStudent } from 'Src/models/schoolStudent';
import {
  SchoolUnionSchoolStudentForm,
  SchoolUnionSchoolStudentFormHandle
} from 'Src/components/SchoolUnionSchoolStudentForm/SchoolUnionSchoolStudentForm';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { SchoolUnionSelectSchoolForm } from 'Src/components/SchoolUnionSelectSchoolForm/SchoolUnionSelectSchoolForm';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UnsavedChangesModal } from 'Src/components/UnsavedChangesModal/UnsavedChangesModal';
import { TOURNAMENT_SCHOOL_LOGO_FALLBACK } from 'Src/consts/tournament';
import { getSchoolUnionSchools } from 'Src/helpers/service/adminSU/schoolsTable';
import { Switch } from 'Src/components/Switch/Switch';
import '../HighLevelTournaments.scss';
import '../../../AdminView/Tournaments/TournamentEvents.css';
import { TournamentSelectionSources } from 'Src/components/TournamentSelectionSources/TournamentSelectionSources';
import { SelectionSource } from 'Src/helpers/service/adminSU/highLevelTournament';
import '../HighLevelTournamentWorkflow.scss';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  recruitingSchoolsPage?: boolean;
}

interface NormalizedTeamPlayer {
  id: string;
  playerId: string;
  permissionId: string;
  form: any;
  gender: string;
  birthday?: string;
  firstName: string;
  lastName: string;
  schoolName?: string;
  schoolId?: string;
  selectionSources?: SelectionSource[];
}

interface State {
  items: SchoolStudent[];
  itemsSelected: SchoolStudent[];
  itemsCount: number;

  itemsFilters: any;
  isShowItemsFilter: boolean;
  isItemsFiltered: boolean;

  isSelectAllItemsChecked: boolean;

  sortItemsDirection: TABLE_SORT_DIRECTION;
  sortItemsColumnsName: string;

  itemCurrentPage: number;

  itemsAccumulatorInitial: NormalizedTeamPlayer[];
  itemsAccumulator: NormalizedTeamPlayer[];
  itemsAccumulatorSelected: NormalizedTeamPlayer[];
  itemsAccumulatorCount: number;

  itemsAccumulatorFilters: any;
  isShowItemsAccumulatorFilter: boolean;
  isItemsAccumulatorFiltered: boolean;

  isSelectAllItemsAccumulatorChecked: boolean;

  sortItemsAccumulatorDirection: TABLE_SORT_DIRECTION;
  sortItemsAccumulatorColumnsName: string;

  tournament: any;
  team: any;
  forms: SchoolForm[];
  studentForms: SchoolForm[];
  availableSchools: any[];
  sourceSchoolIds: string[];
  isSourceSchoolModalOpen: boolean;
  itemsSearch: string;
  isItemsLoading: boolean;

  isLoading: boolean;

  itemsAddBuffer: SchoolStudent[];
  itemsRemoveBuffer: (NormalizedTeamPlayer | SchoolStudent)[];

  studentEventsModalText: string;
  isStudentEventsModalOpen: boolean;

  isShowYounger: boolean;

  isSelectSchoolModalOpen: boolean;
  chosenSchoolId: string;

  isAddStudentModalOpen: boolean;
  studentToAdd: SchoolStudent | null;

  isEditStudentModalOpen: boolean;
  studentToEdit: SchoolStudent | null;

  errorMessage: string;
  isLeaveAlertOpen: boolean;
}

const DEFAULT_TEAM_PLAYERS_ORDER = 'firstName ASC';

export class HighLevelTournamentTeamPlayersEdit extends Component<Props, State> {
  private studentFormRef = React.createRef<SchoolUnionSchoolStudentFormHandle>();
  private unblockNavigation?: () => void;
  private pendingLocation?: any;
  private itemsRequestId = 0;
  private sourceSchoolsDirty = false;

  preferencesKey = () => `tournamentTeamRecruitmentPreferences:${this.props.user.userId}:${this.props.user.activeSchoolId}:${this.props.user.roleSessionKey}:${this.getTournamentId()}:${this.getTeamId()}`;
  readPreferences = (): any => {
    try {const value = JSON.parse(window.sessionStorage.getItem(this.preferencesKey()) || '{}'); return value && typeof value === 'object' && !Array.isArray(value) ? value : {};} catch (error) {return {};}
  };

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      itemsCount: 0,
      itemsSelected: [],

      itemsFilters: {},
      isShowItemsFilter: false,
      isItemsFiltered: false,

      isSelectAllItemsChecked: false,

      sortItemsDirection: '',
      sortItemsColumnsName: '',

      itemCurrentPage: 1,

      itemsAccumulatorInitial: [],
      itemsAccumulator: [],
      itemsAccumulatorCount: 0,
      itemsAccumulatorSelected: [],

      itemsAccumulatorFilters: {},
      isShowItemsAccumulatorFilter: false,
      isItemsAccumulatorFiltered: false,

      isSelectAllItemsAccumulatorChecked: false,

      sortItemsAccumulatorDirection: '',
      sortItemsAccumulatorColumnsName: '',

      tournament: undefined,
      team: undefined,
      forms: [],
      studentForms: [],
      availableSchools: [],
      sourceSchoolIds: [],
      isSourceSchoolModalOpen: false,
      itemsSearch: '',
      isItemsLoading: false,

      isLoading: true,

      itemsAddBuffer: [],
      itemsRemoveBuffer: [],

      studentEventsModalText: '',
      isStudentEventsModalOpen: false,

      isShowYounger: false,

      isSelectSchoolModalOpen: false,
      chosenSchoolId: '',

      isAddStudentModalOpen: false,
      studentToAdd: null,

      isEditStudentModalOpen: false,
      studentToEdit: null,

      errorMessage: '',
      isLeaveAlertOpen: false
    };
  }

  private getTeamPlayersNormalized(teamPlayers: TournamentTeamPlayer[]): NormalizedTeamPlayer[] {
    return teamPlayers.map(tp => {
      const { id, userId, form, permissionId, gender, firstName, lastName, schoolId, birthday } = tp;

      return {
        id: userId,
        playerId: id,
        form,
        permissionId,
        gender,
        birthday,
        firstName,
        lastName,
        schoolName: propz.get(tp, ['schoolName']) || propz.get(tp, ['school', 'name'], ''),
        schoolId: schoolId || propz.get(tp, ['school', 'id'], ''),
        selectionSources: (tp as any).selectionSources || []
      };
    });
  }

  getItemsColumns = (): ColumnDefinition[] => [
    studentBirthdayColumn,
    {
      text: 'Name',
      field: 'firstName',
      accessor: ['firstName'],
      type: FILTER_TYPE.TEXT,
      isSort: false
    },
    {
      text: 'Surname',
      field: 'lastName',
      accessor: ['lastName'],
      type: FILTER_TYPE.TEXT,
      isSort: false
    },
    {
      text: 'School',
      field: 'schools',
      accessor: ['schoolName'],
      type: FILTER_TYPE.MULTISELECT,
      isSort: false
    },
    {
      text: 'Age',
      field: 'ages',
      isSort: false,
      type: FILTER_TYPE.MULTISELECT,
      accessor: getAge
    },
    {
      text: 'Gender',
      field: 'gender',
      isSort: false,
      type: FILTER_TYPE.MULTISELECT,
      accessor: getGender
    },
    this.getActionsColumn(this.handleEditClick)
  ];

  getItemsAccumulatorColumns = (): ColumnDefinition[] => [
    studentBirthdayColumn,
    {
      text: 'Name',
      field: 'firstName',
      accessor: ['firstName'],
      cell: (item: NormalizedTeamPlayer) => <td>{item.firstName}<TournamentSelectionSources sources={item.selectionSources} /></td>,
      type: FILTER_TYPE.NONE,
      isSort: false
    },
    {
      text: 'Surname',
      field: 'lastName',
      accessor: ['lastName'],
      type: FILTER_TYPE.NONE,
      isSort: false
    },
    {
      text: 'School',
      field: 'schoolName',
      accessor: ['schoolName'],
      type: FILTER_TYPE.NONE,
      isSort: false
    },
    {
      text: 'Form',
      field: 'forms',
      isSort: false,
      type: FILTER_TYPE.NONE,
      accessor: ['form', 'name']
    },
    {
      text: 'Gender',
      field: 'gender',
      isSort: false,
      type: FILTER_TYPE.NONE,
      accessor: getGender
    }
  ];

  getTournamentId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const tournamentId = search.tournamentId;
    return tournamentId as string;
  }

  getTeamId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const teamId = search.teamId;
    return teamId as string;
  }

  getActionsColumn = (onEditClick?: (item: SchoolStudent) => void): ColumnDefinition => ({
    text: '',
    field: 'actions',
    type: FILTER_TYPE.NONE,
    isSort: false,
    cell: (item: SchoolStudent) =>
      onEditClick ? (
        <button
          type="button"
          onClick={e => {
            e.stopPropagation();
            onEditClick(item);
          }}
          className="hlt-edit-btn"
          aria-label={`Edit ${item.firstName} ${item.lastName}`}
          title={`Edit ${item.firstName} ${item.lastName}`}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ) : null
  });

  installNavigationGuard = () => {
    this.unblockNavigation = this.props.history.block(location => {
      if (this.state.isLoading && this.hasUnsavedChanges()) return false;
      if (!this.hasUnsavedChanges()) return undefined;
      this.pendingLocation = location;
      this.setState({ isLeaveAlertOpen: true });
      return false;
    });
  };

  componentDidMount() {
    this.installNavigationGuard();

    this.setState({ isLoading: true });

    const { user } = this.props;
    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    const itemsFilters = getTwoPanelEditorFilters(this.getItemsColumns());
    const isShowItemsFilter = isFilterExist2(itemsFilters);

    const itemsAccumulatorFilters = getTwoPanelEditorFilters(this.getItemsAccumulatorColumns());
    const isShowItemsAccumulatorFilter = isFilterExist2(itemsAccumulatorFilters);
    const isItemsAccumulatorFiltered = isFilterExist2(itemsAccumulatorFilters);

    const ageGroupsNaming = propz.get(user, ['activeSchool', 'ageGroupsNaming'], 'ENGLISH');
    const ageGroupNames = propz.get<string[]>(AGE_GROUPS, [ageGroupsNaming], AGE_GROUPS.ENGLISH);
    const forms = ageGroupNames.map((name, age) => ({ name, age } as SchoolForm));

    BPromise.all([
      getTournament(user, tournamentId),
      getSchoolTournamentTeam(user, tournamentId, teamId),
      getAllSchoolTournamentTeamPlayers(user, tournamentId, teamId),
      getSchoolUnionSchools(user, { where: {}, limit: 200, skip: 0, order: 'name ASC' })
    ])
      .then(([fetchedTournament, fetchedTeam, teamPlayers, schools]) => {
        if (String(fetchedTeam.schoolId) !== String(user.activeSchoolId) || String(fetchedTeam.tournamentId) !== tournamentId || fetchedTeam.removed) throw new Error('This team is not available for your union.');
        const normalizedPlayers = this.getTeamPlayersNormalized(teamPlayers);
        const preferences = this.readPreferences();
        const availableIds = new Set(schools.map(school => String(school.id || school._id)));
        const sourceSchoolIds = Array.isArray(preferences.sourceSchoolIds) ? preferences.sourceSchoolIds.filter(id => availableIds.has(String(id))) : Array.from(
          new Set(normalizedPlayers.map(player => String(player.schoolId || '')).filter(Boolean))
        );
        const defaultItemsFilter = this.getDefaultItemsFilter(fetchedTeam, forms);

        this.setState(
          {
            tournament: fetchedTournament,
            team: fetchedTeam,
            forms,
            availableSchools: Array.isArray(schools) ? schools : [],
            sourceSchoolIds,
            isSourceSchoolModalOpen: false,
            itemsFilters: preferences.itemsFilters || defaultItemsFilter,
            itemsSearch: preferences.itemsSearch || '',
            itemCurrentPage: preferences.itemCurrentPage || 1,
            sortItemsDirection: preferences.sortItemsDirection || '',
            sortItemsColumnsName: preferences.sortItemsColumnsName || '',
            isShowYounger: Boolean(preferences.isShowYounger),
            isShowItemsFilter,
            isItemsFiltered: true,
            itemsAccumulatorInitial: normalizedPlayers,
            itemsAccumulator: normalizedPlayers,
            itemsAccumulatorCount: normalizedPlayers.length,
            itemsAccumulatorFilters,
            isShowItemsAccumulatorFilter,
            isItemsAccumulatorFiltered,
            isLoading: false
          },
          () => {
            if (sourceSchoolIds.length > 0) this.loadEligibleStudents(preferences.itemCurrentPage || 1);
          }
        );
      })
      .catch(error => {
        console.error('Unable to load tournament team members:', error);
        this.setState({
          isLoading: false,
          errorMessage: 'The team members could not be loaded. Please try again.'
        });
      });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const wasDirty = prevState.itemsAddBuffer.length > 0 || prevState.itemsRemoveBuffer.length > 0;
    const isDirty = this.hasUnsavedChanges();
    if (wasDirty === isDirty) return;
    if (isDirty) window.addEventListener('beforeunload', this.onBeforeUnload);
    else window.removeEventListener('beforeunload', this.onBeforeUnload);
  }

  componentWillUnmount() {
    if (this.state.team) {
      const {sourceSchoolIds, itemsFilters, itemsSearch, itemCurrentPage, sortItemsDirection, sortItemsColumnsName, isShowYounger} = this.state;
      try {window.sessionStorage.setItem(this.preferencesKey(), JSON.stringify({sourceSchoolIds, itemsFilters, itemsSearch, itemCurrentPage, sortItemsDirection, sortItemsColumnsName, isShowYounger}));} catch (error) { /* Keep navigation usable when session storage is unavailable. */ }
    }
    window.removeEventListener('beforeunload', this.onBeforeUnload);
    this.itemsRequestId += 1;
    if (this.unblockNavigation) this.unblockNavigation();
  }

  hasUnsavedChanges = () => this.sourceSchoolsDirty || this.state.itemsAddBuffer.length > 0 || this.state.itemsRemoveBuffer.length > 0;

  onBeforeUnload = (event: BeforeUnloadEvent) => {
    if (!this.hasUnsavedChanges()) return;
    event.preventDefault();
    event.returnValue = '';
  };

  loadEligibleStudents = (page = 1) => {
    const { sourceSchoolIds, itemsAccumulator, itemsAddBuffer } = this.state;
    if (sourceSchoolIds.length === 0) {
      this.setState({ items: [], itemsCount: 0, itemCurrentPage: 1, isItemsLoading: false });
      return BPromise.resolve();
    }

    const requestId = ++this.itemsRequestId;
    const filter = this.getItemsFilter(page, itemsAccumulator, itemsAddBuffer);
    this.setState({ isItemsLoading: true, errorMessage: '' });

    return BPromise.resolve(searchSchoolStudents(this.props.user, filter))
      .then(result => {
        if (requestId !== this.itemsRequestId) return;
        this.setState({
          items: result.items,
          itemsCount: result.total,
          itemCurrentPage: page,
          itemsSelected: [],
          isSelectAllItemsChecked: false,
          isItemsLoading: false
        });
      })
      .catch(error => {
        if (requestId !== this.itemsRequestId) return;
        console.error('Unable to load eligible students:', error);
        this.setState({
          items: [],
          itemsCount: 0,
          isItemsLoading: false,
          errorMessage: 'Eligible students could not be loaded. Please try again.'
        });
      });
  };

  onItemClick = (index: number): void => {
    const { items, itemsSelected } = this.state;
    const selectedItem = items[index];

    const existingIndex = itemsSelected.findIndex(i => i.id === selectedItem.id);
    const next = [...itemsSelected];
    if (existingIndex !== -1) {
      next.splice(existingIndex, 1);
    } else {
      next.push(selectedItem);
    }

    this.setState({
      itemsAccumulatorSelected: [],
      itemsSelected: next
    });
  };

  onItemAccumulatorClick = (index: number): void => {
    const { itemsAccumulator, itemsAccumulatorSelected } = this.state;
    const clickedItem = itemsAccumulator[index];

    const existingIndex = itemsAccumulatorSelected.findIndex(i => i.id === clickedItem.id);
    const next = [...itemsAccumulatorSelected];
    if (existingIndex !== -1) {
      next.splice(existingIndex, 1);
    } else {
      next.push(clickedItem);
    }

    this.setState({
      itemsAccumulatorSelected: next,
      itemsSelected: []
    });
  };

  onAddClick = () => {
    const { itemsSelected, itemsAddBuffer, itemsAccumulator, itemCurrentPage } = this.state;

    const nextItemsAddBuffer = [...itemsAddBuffer, ...itemsSelected];

    const itemsToAddNormalized: NormalizedTeamPlayer[] = itemsSelected.map(item => ({
      id: item.id,
      playerId: '',
      permissionId: item.permissionId,
      form: item.form,
      gender: item.gender,
      birthday: item.birthday,
      firstName: item.firstName,
      lastName: item.lastName,
      schoolName: propz.get(item, ['schoolName'], ''),
      schoolId: propz.get(item, ['schoolId'], '')
    }));

    const existingIds = new Set((itemsAccumulator || []).map(x => String(x.id)));
    const nextItemsAccumulator = [
      ...itemsAccumulator,
      ...itemsToAddNormalized.filter(x => !existingIds.has(String(x.id)))
    ];

    this.setState(
      {
        itemsAddBuffer: nextItemsAddBuffer,
        itemsAccumulator: nextItemsAccumulator,
        itemsAccumulatorCount: nextItemsAccumulator.length,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isSelectAllItemsChecked: false
      },
      () => this.loadEligibleStudents(itemCurrentPage)
    );
  };

  onRemoveClick = () => {
    const {
      itemsAccumulatorSelected,
      itemsAddBuffer,
      itemsRemoveBuffer,
      itemsAccumulatorInitial,
      itemsAccumulator,
      itemCurrentPage
    } = this.state;

    const selectedIds = new Set((itemsAccumulatorSelected || []).map(x => String(x.id)));
    const addBufferIds = new Set((itemsAddBuffer || []).map(x => String(x.id)));

    const selectedExistingMembers = (itemsAccumulatorSelected || []).filter(x => !addBufferIds.has(String(x.id)));

    const nextItemsAddBuffer = (itemsAddBuffer || []).filter(x => !selectedIds.has(String(x.id)));

    const existingRemoveIds = new Set((itemsRemoveBuffer || []).map(x => String(x.id)));
    const nextItemsRemoveBuffer = [
      ...(itemsRemoveBuffer || []),
      ...selectedExistingMembers.filter(x => !existingRemoveIds.has(String(x.id)))
    ];

    const nextItemsAccumulatorInitial = (itemsAccumulatorInitial || []).filter(
      accItem => !nextItemsRemoveBuffer.some(rem => String(rem.id) === String(accItem.id))
    );

    const nextItemsAccumulator = (itemsAccumulator || []).filter(accItem => !selectedIds.has(String(accItem.id)));

    this.setState(
      {
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isSelectAllItemsChecked: false,
        itemsAddBuffer: nextItemsAddBuffer,
        itemsRemoveBuffer: nextItemsRemoveBuffer,
        itemsAccumulatorInitial: nextItemsAccumulatorInitial,
        itemsAccumulator: nextItemsAccumulator,
        itemsAccumulatorCount: nextItemsAccumulator.length
      },
      () => this.loadEligibleStudents(itemCurrentPage)
    );
  };

  removeItemFromBuffer = (itemId: string) => {
    this.setState(prev => {
      const found = prev.itemsAddBuffer.find(x => x.id === itemId);
      const updated = prev.itemsAddBuffer.filter(x => x.id !== itemId);

      const updatedItems = found ? [...prev.items, found] : prev.items;
      return {
        itemsAddBuffer: updated,
        items: updatedItems
      };
    });
  };

  onClickSave = () => {
    const { itemsAddBuffer, itemsRemoveBuffer, team, forms } = this.state;
    const { user } = this.props;

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    const data: SchoolTournamentTeamPlayersBatchData = {
      add: itemsAddBuffer.map(item => ({
        userId: item.id,
        permissionId: item.permissionId
      })),
      remove: itemsRemoveBuffer
        .map(remItem => {
          const maybeTP = remItem as NormalizedTeamPlayer;
          return maybeTP.playerId || null;
        })
        .filter(Boolean)
    };

    const defaultItemsFilter = this.getDefaultItemsFilter(team, forms);

    this.setState({
      isLoading: true,
      itemsSelected: [],
      itemsFilters: defaultItemsFilter,
      isShowItemsFilter: false,
      isItemsFiltered: true,
      isSelectAllItemsChecked: false,
      sortItemsDirection: '',
      sortItemsColumnsName: '',
      itemCurrentPage: 1,
      itemsAccumulatorSelected: [],
      itemsAccumulatorFilters: {},
      isShowItemsAccumulatorFilter: false,
      isItemsAccumulatorFiltered: false,
      isSelectAllItemsAccumulatorChecked: false,
      sortItemsAccumulatorDirection: '',
      sortItemsAccumulatorColumnsName: '',
      errorMessage: ''
    });

    updateSchoolTournamentTeamPlayersBatch(user, tournamentId, teamId, data)
      .then(() => {
        return getAllSchoolTournamentTeamPlayers(user, tournamentId, teamId);
      })
      .then(unfilteredTeamPlayers => {
        const normalizedFinalTeam = this.getTeamPlayersNormalized(unfilteredTeamPlayers);

        this.setState({
          itemsAccumulatorInitial: normalizedFinalTeam,
          itemsAccumulator: normalizedFinalTeam,
          itemsAccumulatorCount: normalizedFinalTeam.length
        });

        const filter = this.getItemsFilter(1, normalizedFinalTeam, []);
        return searchSchoolStudents(user, filter);
      })
      .then(result => {
        this.setState({
          items: result.items,
          itemsCount: result.total,
          itemsAddBuffer: [],
          itemsRemoveBuffer: [],
          isLoading: false
        });
      })
      .catch(err => {
        console.error('Error on save:', err);
        this.setState({
          isLoading: false,
          errorMessage: 'Failed to save changes.'
        });
      });
  };

  onItemsFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (filterField === 'ages') {
      nextFilters.forms = [];
    }

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const col = this.getItemsColumns().find(c => c.field === filterField);
      if (!col) return;

      const filterType = col.type;
      if (filterType === FILTER_TYPE.MULTISELECT) {
        const opts = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < opts.length; i++) {
          if (opts[i].selected) {
            value.push(opts[i].value);
          }
        }
        nextFilters[filterField] = value;
      } else {
        nextFilters[filterField] = filterValue;
      }
    }

    this.setState({ itemsFilters: nextFilters });
  };

  onItemsAccumulatorFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsAccumulatorFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const col = this.getItemsAccumulatorColumns().find(c => c.field === filterField);
      if (!col) return;

      const filterType = col.type;
      if (filterType === FILTER_TYPE.MULTISELECT) {
        const opts = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < opts.length; i++) {
          if (opts[i].selected) {
            value.push(opts[i].value);
          }
        }
        nextFilters[filterField] = value;
      } else {
        nextFilters[filterField] = filterValue;
      }
    }

    this.setState({ itemsAccumulatorFilters: nextFilters });
  };

  onItemsFilterClick = (event): void => {
    event.preventDefault();
    this.setState(prev => ({
      isShowItemsFilter: !prev.isShowItemsFilter
    }));
  };

  onItemsAccumulatorFilterClick = (event): void => {
    event.preventDefault();
    this.setState(prev => ({
      isShowItemsAccumulatorFilter: !prev.isShowItemsAccumulatorFilter
    }));
  };

  getItemsFilter(
    page: number,
    itemsAccumulator: (TournamentTeamPlayer | NormalizedTeamPlayer)[],
    itemsAddBuffer: SchoolStudent[],
    isAllItems = false,
    orderOverride?: string
  ) {
    const { itemsFilters, itemsSearch, sourceSchoolIds } = this.state;

    const {
      gender: itemsFiltersGender,
      ages: itemsFiltersAges = [],
      firstName: itemsFiltersFirstName = '',
      lastName: itemsFiltersLastName = '',
      schools: itemsFiltersSchools = [],
      forms: itemsFiltersForms = []
    } = itemsFilters;

    const selectedSchoolIds =
      itemsFiltersSchools.length > 0
        ? sourceSchoolIds.filter(id => itemsFiltersSchools.map(String).includes(String(id)))
        : sourceSchoolIds;

    let where: any = {
      gender: {
        $in: itemsFiltersGender
      },
      schoolId: {
        $in: selectedSchoolIds
      }
    };

    const allLeft = [...itemsAccumulator, ...itemsAddBuffer];
    const ninIds = Lazy(allLeft)
      .map(it => it.id)
      .uniq()
      .toArray();
    propz.set(where, ['_id', '$nin'], ninIds);

    if (itemsFiltersForms.length > 0) {
      propz.set(where, ['formAge', '$in'], itemsFiltersForms.map(Number));
    } else {
      const ages = itemsFiltersAges.length > 0 ? itemsFiltersAges : AGE_GROUPS.ENGLISH.map((_, idx) => idx);
      if (ages.length > 0) {
        propz.set(where, ['formAge', '$in'], ages.map(Number));
      }
    }

    const andArr: any[] = [];
    if (itemsFiltersFirstName.length > 0) {
      andArr.push({ firstName: { like: itemsFiltersFirstName, options: 'i' } });
    }
    if (itemsFiltersLastName.length > 0) {
      andArr.push({ lastName: { like: itemsFiltersLastName, options: 'i' } });
    }
    if (itemsSearch.trim().length > 0) {
      const searchValue = itemsSearch.trim();
      andArr.push({
        $or: [{ firstName: { like: searchValue, options: 'i' } }, { lastName: { like: searchValue, options: 'i' } }]
      });
    }
    if (andArr.length > 0) {
      propz.set(where, ['$and'], andArr);
    }

    return {
      where,
      limit: isAllItems ? DEFAULT_LIMIT : LIMIT,
      skip: isAllItems ? 0 : (page - 1) * LIMIT,
      order: orderOverride || DEFAULT_TEAM_PLAYERS_ORDER
    };
  }

  itemsSetCurrentPageParams = (currentPage: number): void => {
    const { itemsAccumulator, sortItemsColumnsName, sortItemsDirection, itemsAddBuffer, itemsCount } = this.state;
    const lastPage = Math.max(1, Math.ceil(itemsCount / LIMIT));
    const safePage = Math.min(Math.max(1, currentPage), lastPage);
    const orderForFilter =
      sortItemsColumnsName && sortItemsDirection ? `${sortItemsColumnsName} ${sortItemsDirection}` : undefined;
    const pageFilter = this.getItemsFilter(safePage, itemsAccumulator, itemsAddBuffer, false, orderForFilter);
    const requestId = ++this.itemsRequestId;

    this.setState({ isItemsLoading: true });
    searchSchoolStudents(this.props.user, pageFilter)
      .then(result => {
        if (requestId !== this.itemsRequestId) return;
        this.setState({
          itemCurrentPage: safePage,
          items: result.items,
          itemsCount: result.total,
          isItemsLoading: false
        });
      })
      .catch(error => {
        if (requestId !== this.itemsRequestId) return;
        console.error('Unable to change eligible students page:', error);
        this.setState({ isItemsLoading: false, errorMessage: 'The next page could not be loaded.' });
      });
  };

  itemsOnApplyFilterClick = () => {
    this.setState(
      {
        isShowYounger: false,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsDirection: '',
        sortItemsColumnsName: ''
      },
      () => this.loadEligibleStudents(1)
    );
  };

  onReplaceItemsFilters = (filters: any) => {
    this.setState({ itemsFilters: filters }, () => this.itemsOnApplyFilterClick());
  };

  onItemsSearchChange = (itemsSearch: string) => {
    this.itemsRequestId += 1;
    this.setState({ itemsSearch, isItemsLoading: true }, () => this.loadEligibleStudents(1));
  };

  itemsAccumulatorOnApplyFilterClick = () => {};

  itemsOnClearFilterClick = () => {
    const { team, forms } = this.state;

    const defaultItemsFilter = this.getDefaultItemsFilter(team, forms);
    this.setState(
      {
        itemsFilters: defaultItemsFilter,
        isShowYounger: false,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: '',
        sortItemsDirection: '',
        isItemsFiltered: true,
        isShowItemsFilter: false
      },
      () => this.loadEligibleStudents(1)
    );
  };

  itemsAccumulatorOnClearFilterClick = () => {};

  getFormsFiltered(ages: number[], forms: SchoolForm[], isStrictEqual: boolean) {
    const maxAge = Math.max(...ages);
    const minAge = Math.min(...ages);

    switch (true) {
      case isStrictEqual && ages.length === 1:
        return forms.filter(form => form.age === minAge);
      case !isStrictEqual && ages.length === 1:
        return forms.filter(form => form.age <= maxAge);
      case isStrictEqual && ages.length > 1:
        return forms.filter(form => ages.some(age => form.age === age));
      case !isStrictEqual && ages.length > 1:
        return forms.filter(form => ages.some(age => form.age <= age));
      default:
        return forms;
    }
  }

  getDefaultItemsFilter(team, forms, isStrictEqual = true) {
    const { gender, ages = [] } = team;
    const genderArrayConverted = getUserGenderArrayConvertedFromEventGender(gender);
    const formsFiltered = this.getFormsFiltered(ages, forms, isStrictEqual);
    const formAges = Array.from(new Set(formsFiltered.map(form => Number(form.age))));
    return {
      firstName: '',
      lastName: '',
      schools: [],
      gender: genderArrayConverted,
      ages: ages.map(String),
      forms: formAges.map(String)
    };
  }

  goBack = (force = false) => {
    if (this.hasUnsavedChanges() && !force) {
      this.setState({ isLeaveAlertOpen: true });
      return;
    }

    const { location } = this.props;
    const prevPath = propz.get(location, ['state', 'prevPath'], '/highLevelTournaments/upcoming');
    const tournamentId = this.getTournamentId();

    this.props.history.push({
      pathname: '/highLevelTournaments/teams',
      search: `tournamentId=${tournamentId}`,
      state: { tournamentId, prevPath }
    });
  };

  confirmLeave = () => {
    this.sourceSchoolsDirty = false;
    const pendingLocation = this.pendingLocation;
    this.pendingLocation = undefined;
    this.setState({ itemsAddBuffer: [], itemsRemoveBuffer: [], isLeaveAlertOpen: false }, () => {
      if (this.unblockNavigation) {
        this.unblockNavigation();
        this.unblockNavigation = undefined;
      }
      if (pendingLocation) {
        this.props.history.push(pendingLocation);
        this.installNavigationGuard();
        return;
      }
      this.goBack(true);
    });
  };

  keepEditing = () => {
    this.pendingLocation = undefined;
    this.setState({ isLeaveAlertOpen: false });
  };

  onSelectAllItemsClick = () => {
    const { itemsSelected, itemCurrentPage, itemsAccumulatorInitial, itemsAddBuffer } = this.state;
    const { user } = this.props;

    this.setState({ isLoading: true });

    const nextBuffer = [...itemsAddBuffer, ...itemsSelected];
    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulatorInitial, nextBuffer, true);

    getSchoolStudentsList(user, filter).then(all => {
      const newOnes = all.filter(x => itemsSelected.every(sel => sel.id !== x.id));
      const nextSelected = [...itemsSelected, ...newOnes];

      this.setState({
        itemsSelected: nextSelected,
        isSelectAllItemsChecked: true,
        itemsAccumulatorSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isLoading: false
      });
    });
  };

  onSelectAllItemsOnPageClick = () => {
    const { items, itemsSelected } = this.state;
    const newOnes = items.filter(x => itemsSelected.every(sel => sel.id !== x.id));
    const nextSelected = [...itemsSelected, ...newOnes];

    this.setState({
      itemsSelected: nextSelected,
      isSelectAllItemsChecked: true,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onUnselectAllItemsClick = () => {
    this.setState({
      itemsSelected: [],
      isSelectAllItemsChecked: false,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onSelectAllItemsAccumulatorClick = () => {
    const { itemsAccumulatorSelected, itemsAccumulatorFilters } = this.state;
    const { user } = this.props;

    this.setState({ isLoading: true });

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();
    const where = getServerFieldSectionWhere(itemsAccumulatorFilters);

    getAllSchoolTournamentTeamPlayers(user, tournamentId, teamId, where).then(tpList => {
      const normalized = this.getTeamPlayersNormalized(tpList);
      const newOnes = normalized.filter(tp => itemsAccumulatorSelected.every(sel => sel.id !== tp.id));

      this.setState({
        itemsAccumulatorSelected: [...itemsAccumulatorSelected, ...newOnes],
        isSelectAllItemsAccumulatorChecked: true,
        itemsSelected: [],
        isSelectAllItemsChecked: false,
        isLoading: false
      });
    });
  };

  onSelectAllItemsAccumulatorOnPageClick = () => {
    const { itemsAccumulator, itemsAccumulatorSelected } = this.state;
    const newOnes = itemsAccumulator.filter(x => itemsAccumulatorSelected.every(sel => sel.id !== x.id));
    this.setState({
      itemsAccumulatorSelected: [...itemsAccumulatorSelected, ...newOnes],
      isSelectAllItemsAccumulatorChecked: true,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onUnselectAllItemsAccumulatorClick = () => {
    this.setState({
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onSortItemsClick = (sortField: string) => {
    const { sortItemsDirection, sortItemsColumnsName, itemCurrentPage, itemsAccumulator, itemsAddBuffer } = this.state;

    const order = getOrder(sortField, sortItemsDirection, sortItemsColumnsName) as TABLE_SORT_DIRECTION;
    const orderForFilter = `${sortField} ${order}`;
    const { user } = this.props;

    this.setState({ isItemsLoading: true });

    const pageFilter = this.getItemsFilter(itemCurrentPage, itemsAccumulator, itemsAddBuffer, false, orderForFilter);
    searchSchoolStudents(user, pageFilter).then(result => {
      this.setState({
        items: result.items,
        itemsCount: result.total,
        isItemsLoading: false,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: sortField,
        sortItemsDirection: order
      });
    });
  };

  onSortItemsAccumulatorClick = (sortField: string) => {};

  onCloseStudentEventsModalClick = () => {
    this.setState({ isStudentEventsModalOpen: false });
  };

  onSchoolSelected = async (schoolId: string) => {
    this.setState({
      isSelectSchoolModalOpen: false,
      chosenSchoolId: schoolId
    });

    try {
      const [forms] = await Promise.all([getAllSchoolUnionSchoolForms(this.props.user, schoolId)]);
      this.setState({ studentForms: forms });
      this.openAddStudentModal();
    } catch (err) {
      console.error('Error fetching forms:', err);
    }
  };

  openAddStudentModal = () => {
    this.setState({
      isAddStudentModalOpen: true,
      studentToAdd: null,
      errorMessage: ''
    });
  };

  closeAddStudentModal = () => {
    this.setState({
      isAddStudentModalOpen: false,
      studentToAdd: null,
      errorMessage: ''
    });
  };

  handleEditClick = async (student: SchoolStudent) => {
    try {
      const studentForms = await getAllSchoolUnionSchoolForms(this.props.user, student.schoolId);
      this.setState({
        isEditStudentModalOpen: true,
        studentToEdit: student,
        studentForms,
        errorMessage: ''
      });
    } catch (error) {
      console.error('Unable to load the student school forms:', error);
      this.setState({ errorMessage: 'The student details could not be opened.' });
    }
  };

  closeEditStudentModal = () => {
    this.setState({
      isEditStudentModalOpen: false,
      studentToEdit: null,
      errorMessage: ''
    });
  };

  renderSelectSchoolModal() {
    const { user } = this.props;
    const { isSelectSchoolModalOpen } = this.state;

    return (
      <SchoolUnionSelectSchoolForm
        user={user}
        isOpen={isSelectSchoolModalOpen}
        onClose={this.closeSelectSchoolModal}
        onContinue={this.onSchoolSelected}
      />
    );
  }

  openSelectSchoolModal = () => {
    this.setState({
      isSelectSchoolModalOpen: true,
      chosenSchoolId: ''
    });
  };

  closeSelectSchoolModal = () => {
    this.setState({
      isSelectSchoolModalOpen: false
    });
  };

  renderAddStudentModal() {
    const { isAddStudentModalOpen, studentToAdd, studentForms } = this.state;
    const { user } = this.props;
    if (!isAddStudentModalOpen) return null;

    return (
      <SimpleModal
        isOpen={isAddStudentModalOpen}
        onCloseClick={() => this.studentFormRef.current?.requestClose()}
        title="Add Student"
        showFooter={false}
        customClass="unionStudentModal"
        dialogStyle={{ maxWidth: 560 }}
      >
        <SchoolUnionSchoolStudentForm
          ref={this.studentFormRef}
          student={studentToAdd || { firstName: '', lastName: '', formId: '' }}
          onSubmit={this.onSubmitAddStudent}
          onCancel={this.closeAddStudentModal}
          user={user}
          isCreateStudentsChain={false}
          identicalStudents={[]}
          similarStudents={[]}
          isFormsExist={studentForms && studentForms.length > 0}
          isEditStudent={false}
          schoolId={this.state.chosenSchoolId}
        />
      </SimpleModal>
    );
  }

  renderEditStudentModal() {
    const { isEditStudentModalOpen, studentToEdit, studentForms } = this.state;
    const { user } = this.props;
    if (!isEditStudentModalOpen || !studentToEdit) return null;

    return (
      <SimpleModal
        isOpen={isEditStudentModalOpen}
        onCloseClick={() => this.studentFormRef.current?.requestClose()}
        title="Edit Student"
        showFooter={false}
        customClass="unionStudentModal"
        dialogStyle={{ maxWidth: 560 }}
      >
        <SchoolUnionSchoolStudentForm
          ref={this.studentFormRef}
          student={studentToEdit}
          user={user}
          onSubmit={this.onSubmitEditStudent}
          onCancel={this.closeEditStudentModal}
          isCreateStudentsChain={false}
          identicalStudents={[]}
          similarStudents={[]}
          isFormsExist={studentForms && studentForms.length > 0}
          isEditStudent={true}
          schoolId={studentToEdit.schoolId}
        />
      </SimpleModal>
    );
  }

  onSubmitAddStudent = async (
    studentData: any,
    isContinue: boolean,
    isSavingSimilarStudentConfirmed: boolean = false
  ): Promise<boolean> => {
    const { user } = this.props;
    const { chosenSchoolId } = this.state;

    try {
      await addSchoolUnionSchoolStudent(user, chosenSchoolId, studentData);

      this.setState(
        prev => ({
          sourceSchoolIds: prev.sourceSchoolIds.includes(chosenSchoolId)
            ? prev.sourceSchoolIds
            : [...prev.sourceSchoolIds, chosenSchoolId]
        }),
        () => this.loadEligibleStudents(1)
      );

      if (!isContinue) {
        this.closeAddStudentModal();
      }
      return true;
    } catch (err) {
      console.error('Failed to add student:', err);
      return false;
    }
  };

  onSubmitEditStudent = async (
    formData: any,
    isContinue: boolean,
    isSavingSimilarStudentConfirmed: boolean = false
  ): Promise<boolean> => {
    const { user } = this.props;
    const { studentToEdit } = this.state;

    if (!studentToEdit) return false;

    try {
      await updateSchoolUnionSchoolStudent(user, studentToEdit.schoolId, studentToEdit.id, formData);

      this.setState(prev => {
        const updatedItems = prev.items.map(st => (st.id === studentToEdit.id ? { ...st, ...formData } : st));
        const updatedAccumulator = prev.itemsAccumulator.map(st =>
          st.id === studentToEdit.id ? { ...st, ...formData } : st
        );
        return {
          items: updatedItems,
          itemsAccumulator: updatedAccumulator
        };
      });

      this.closeEditStudentModal();
      return true;
    } catch (err) {
      console.error('Edit student error:', err);
      return false;
    }
  };

  renderStudentEventsModal(): React.ReactNode {
    const { isStudentEventsModalOpen, studentEventsModalText } = this.state;
    return (
      <SimpleModal
        isOpen={isStudentEventsModalOpen}
        title="Info"
        body={studentEventsModalText}
        buttonText="Ok"
        onButtonClick={this.onCloseStudentEventsModalClick}
      />
    );
  }

  onShowYoungerChange = () => {
    const { team, forms, isShowYounger } = this.state;

    const defaultItemsFilter = this.getDefaultItemsFilter(team, forms, isShowYounger);

    this.setState(
      {
        itemsFilters: defaultItemsFilter,
        isShowYounger: !isShowYounger,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: '',
        sortItemsDirection: '',
        isItemsFiltered: true,
        isShowItemsFilter: false
      },
      () => this.loadEligibleStudents(1)
    );
  };

  render() {
    const {
      items,
      isLoading,
      itemsSelected,
      itemsAccumulatorSelected,
      itemsAccumulator,
      itemsFilters,
      isShowItemsFilter,
      isItemsFiltered,
      itemsCount,
      itemsAccumulatorCount,
      itemCurrentPage,
      itemsAccumulatorFilters,
      isShowItemsAccumulatorFilter,
      isItemsAccumulatorFiltered,
      tournament,
      isSelectAllItemsChecked,
      isSelectAllItemsAccumulatorChecked,
      sortItemsDirection,
      sortItemsColumnsName,
      sortItemsAccumulatorDirection,
      sortItemsAccumulatorColumnsName,
      itemsAddBuffer,
      itemsRemoveBuffer,
      isStudentEventsModalOpen,
      forms,
      isShowYounger,
      team,
      errorMessage,
      isLeaveAlertOpen,
      availableSchools,
      sourceSchoolIds,
      itemsSearch,
      isItemsLoading
    } = this.state;

    const name = propz.get(tournament, ['name'], '');

    if (isLoading) {
      return <Loader />;
    }

    if (!tournament || !team) {
      if (!errorMessage) {
        return <Loader />;
      }

      return (
        <main className="tournamentTeamPlayersModern hltTeamMembers">
          <section className="tournamentTeamPlayersModern__error" role="alert">
            {errorMessage}
          </section>
          <button type="button" className="tournamentTeamPlayersModern__back" onClick={() => this.goBack(true)}>
            <span aria-hidden="true">←</span> Back to teams
          </button>
        </main>
      );
    }

    if (this.props.recruitingSchoolsPage) {return <main className="tournamentTeamPlayersModern hltTeamMembers">
      <UnsavedChangesModal isOpen={isLeaveAlertOpen} message="Your recruiting school selection has not been applied. Discard it and leave?" onKeepEditing={this.keepEditing} onDiscard={this.confirmLeave} />
      {this.renderSourceSchoolModal()}
    </main>;}

    const { user } = this.props;
    const ageGroupsNaming = propz.get(user, ['activeSchool', 'ageGroupsNaming'], 'ENGLISH');

    const sourceSchools = sourceSchoolIds.map(schoolId => {
      const school = availableSchools.find(item => String(item.id || item._id) === String(schoolId));
      const teamMember = itemsAccumulator.find(item => String(item.schoolId) === String(schoolId));
      return {
        id: schoolId,
        name: propz.get(school, ['name'], '') || propz.get(teamMember, ['schoolName'], '') || 'Unknown school'
      };
    });

    const filterForms = this.getFormsFiltered(propz.get(team, ['ages'], []), forms, !isShowYounger);
    const itemsFiltersOptions = {
      ages: getSelectOptionForAge(filterForms, ageGroupsNaming),
      gender: getSelectOptionForGender(),
      schools: sourceSchools.map(school => ({ text: school.name, value: school.id }))
    };

    const itemsAccumulatorFiltersOptions = {};

    const teamName = propz.get(team, ['name'], 'Tournament team');
    const schoolName = propz.get(team, ['school', 'name'], '') || propz.get(user, ['activeSchoolName'], '');
    const schoolLogo = propz.get(team, ['school', 'pic'], '') || TOURNAMENT_SCHOOL_LOGO_FALLBACK;
    const ageLabel = formatTournamentAges(propz.get(team, ['ages'], [])) || 'Age not set';
    const genderLabel = getTeamGender(team) || 'Gender not set';
    const pendingChangesCount = itemsAddBuffer.length + itemsRemoveBuffer.length;
    const stagedParticipantsCount = itemsAccumulatorCount;
    const teamCapacity = Number(
      propz.get(team, ['numberOfStudents'], 0) || propz.get(tournament, ['maxPlayersPerTeam'], 0) || 0
    );
    const isTeamCapacityExceeded = teamCapacity > 0 && stagedParticipantsCount > teamCapacity;

    return (
      <main className={`tournamentTeamPlayersModern hltTeamMembers${isStudentEventsModalOpen ? ' modal-open' : ''}`}>
        <UnsavedChangesModal
          isOpen={isLeaveAlertOpen}
          message="You have unsaved team member changes. If you leave now, those changes will be lost."
          onKeepEditing={this.keepEditing}
          onDiscard={this.confirmLeave}
        />
        {this.renderStudentEventsModal()}
        {this.renderSelectSchoolModal()}
        {this.renderSourceSchoolModal()}
        {this.renderAddStudentModal()}
        {this.renderEditStudentModal()}

        <header className="tournamentTeamPlayersModern__header">
          <button type="button" className="tournamentTeamPlayersModern__back" onClick={() => this.goBack()}>
            <span aria-hidden="true">←</span> Back to teams
          </button>
          <div className="tournamentTeamPlayersModern__headingRow">
            <div className="tournamentTeamPlayersModern__identity">
              <div className="tournamentTeamPlayersModern__contextTitle">
                Managing team members for <strong>{name}</strong>
              </div>
              <div className="tournamentTeamPlayersModern__teamDetails">
                <img src={schoolLogo} alt="" />
                <div>
                  <strong>{teamName}</strong>
                  <span>{schoolName || 'High-level tournament team'}</span>
                </div>
              </div>
            </div>
            <div className="tournamentTeamPlayersModern__summary">
              <span className={isTeamCapacityExceeded ? 'is-over-limit' : undefined}>
                <strong>{stagedParticipantsCount}</strong> participants
                {isTeamCapacityExceeded && ` · ${stagedParticipantsCount - teamCapacity} over limit`}
              </span>
              <span>
                <strong>{ageLabel}</strong>
              </span>
              <span>
                <strong>{genderLabel}</strong>
              </span>
              {teamCapacity > 0 && (
                <span className={isTeamCapacityExceeded ? 'is-over-limit' : 'is-available'}>
                  <strong>{Math.max(0, teamCapacity - stagedParticipantsCount)}</strong> places available
                </span>
              )}
            </div>
          </div>
          <div className="tournamentTeamPlayersModern__toolbar">
            <span className="hltTeamMembers__toolbarHint">
              Candidate searches are limited to the selected recruiting schools.
            </span>
            <div className="tournamentTeamPlayersModern__toolbarActions">
              {['ADMIN', 'MANAGER'].includes(user.activeRole) && <button type="button" disabled={pendingChangesCount > 0}
                title={pendingChangesCount > 0 ? 'Save or discard your current roster changes first' : 'Select students from tournament results'}
                onClick={() => this.openRecruitmentPage('recruit')}>Add from tournaments</button>}
              <button type="button" onClick={this.openSelectSchoolModal}>
                <span aria-hidden="true">＋</span> Create student
              </button>
            </div>
          </div>
        </header>

        <section className="tournamentTeamPlayersModern__card">
          <div className="tournamentTeamPlayersModern__cardHead">
            <div>
              <h2>Build the team</h2>
              <p>
                Double-click a student to move them instantly, or select several and use the centre buttons. Changes are
                applied only when you save.
              </p>
            </div>
          </div>
          <div className="hltTeamMembers__sourceScope">
            <div className="hltTeamMembers__sourceScopeLabel">
              <span>Recruiting schools</span>
              <div>
                {sourceSchools.slice(0, 4).map(school => (
                  <span key={school.id} title={school.name}>
                    {school.name}
                  </span>
                ))}
                {sourceSchools.length > 4 && <span>+{sourceSchools.length - 4}</span>}
                {sourceSchools.length === 0 && <em>No schools selected</em>}
              </div>
            </div>
            <button type="button" onClick={this.openSourceSchoolModal}>
              {sourceSchools.length > 0 ? 'Change schools' : 'Choose schools'}
            </button>
          </div>
          {sourceSchools.length === 0 && (
            <div className="hltTeamMembers__sourceEmpty">
              Choose at least one member school to load eligible students.
            </div>
          )}
          <div className="tournamentTeamPlayersModern__editor">
            <TwoPanelEditor
              isSourceFirst
              unitLabel="students"
              itemsModernPagination
              itemsAllowSelectAllFiltered={false}
              showAvatars
              items={items}
              itemsTitle="Eligible students"
              itemsColumns={this.getItemsColumns()}
              itemsSelected={itemsSelected}
              onItemClick={this.onItemClick}
              onItemsFilterChange={this.onItemsFilterChange}
              itemsFilters={itemsFilters}
              itemsFiltersOptions={itemsFiltersOptions}
              itemsFilterLabels={{ ages: 'Age group', forms: 'Year group', schools: 'School' }}
              onReplaceItemsFilters={this.onReplaceItemsFilters}
              onItemsSearchChange={this.onItemsSearchChange}
              itemsSearchValue={itemsSearch}
              isItemsLoading={isItemsLoading}
              isShowItemsFilter={isShowItemsFilter}
              isItemsFiltered={isItemsFiltered}
              onItemsFilterClick={this.onItemsFilterClick}
              itemsHeaderExtra={
                <Switch
                  name="isShowYounger"
                  checked={isShowYounger}
                  onChange={this.onShowYoungerChange}
                  text="Show younger students"
                />
              }
              itemsAccumulator={itemsAccumulator}
              itemsAccumulatorTitle="Team members"
              itemsAccumulatorSearchByNameOnly
              itemsAccumulatorColumns={this.getItemsAccumulatorColumns()}
              onItemAccumulatorClick={this.onItemAccumulatorClick}
              itemsAccumulatorSelected={itemsAccumulatorSelected}
              onItemsAccumulatorFilterChange={this.onItemsAccumulatorFilterChange}
              itemsAccumulatorFilters={itemsAccumulatorFilters}
              itemsAccumulatorFiltersOptions={itemsAccumulatorFiltersOptions}
              isShowItemsAccumulatorFilter={isShowItemsAccumulatorFilter}
              isItemsAccumulatorFiltered={isItemsAccumulatorFiltered}
              onItemsAccumulatorFilterClick={this.onItemsAccumulatorFilterClick}
              onAddClick={this.onAddClick}
              onRemoveClick={this.onRemoveClick}
              itemsCount={itemsCount}
              itemsAccumulatorCount={itemsAccumulatorCount}
              itemsAccumulatorCapacity={teamCapacity > 0 ? teamCapacity : undefined}
              itemAccumulatorCurrentPage={1}
              itemCurrentPage={itemCurrentPage}
              itemsSetCurrentPageParams={this.itemsSetCurrentPageParams}
              itemsOnApplyFilterClick={this.itemsOnApplyFilterClick}
              itemsOnClearFilterClick={this.itemsOnClearFilterClick}
              itemsAccumulatorOnApplyFilterClick={this.itemsAccumulatorOnApplyFilterClick}
              itemsAccumulatorOnClearFilterClick={this.itemsAccumulatorOnClearFilterClick}
              onSelectAllItemsClick={this.onSelectAllItemsClick}
              onSelectAllItemsOnPageClick={this.onSelectAllItemsOnPageClick}
              onUnselectAllItemsClick={this.onUnselectAllItemsClick}
              isSelectAllItemsChecked={isSelectAllItemsChecked}
              onSelectAllItemsAccumulatorClick={this.onSelectAllItemsAccumulatorClick}
              onSelectAllItemsAccumulatorOnPageClick={this.onSelectAllItemsAccumulatorOnPageClick}
              onUnselectAllItemsAccumulatorClick={this.onUnselectAllItemsAccumulatorClick}
              isSelectAllItemsAccumulatorChecked={isSelectAllItemsAccumulatorChecked}
              sortItemsDirection={sortItemsDirection}
              sortItemsColumnsName={sortItemsColumnsName}
              onSortItemsClick={this.onSortItemsClick}
              sortItemsAccumulatorDirection={sortItemsAccumulatorDirection}
              sortItemsAccumulatorColumnsName={sortItemsAccumulatorColumnsName}
              onSortItemsAccumulatorClick={this.onSortItemsAccumulatorClick}
              itemsAddBuffer={itemsAddBuffer}
              itemsRemoveBuffer={itemsRemoveBuffer}
              onCellItemsClick={() => {}}
              onCellItemsAccumulatorClick={() => {}}
              removeItemFromBuffer={this.removeItemFromBuffer}
              onEditClick={this.handleEditClick}
            />
          </div>
        </section>

        {errorMessage && (
          <div className="tournamentTeamPlayersModern__error" role="alert">
            {errorMessage}
          </div>
        )}

        <footer className="tournamentTeamPlayersModern__footer">
          <div>
            <strong>{stagedParticipantsCount} selected</strong>
            {pendingChangesCount > 0 && (
              <span>
                {pendingChangesCount} unsaved {pendingChangesCount === 1 ? 'change' : 'changes'}
              </span>
            )}
          </div>
          <div>
            <button type="button" className="isSecondary" onClick={() => this.goBack()}>
              Cancel
            </button>
            <button type="button" className="isPrimary" onClick={this.onClickSave} disabled={!this.hasUnsavedChanges()}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
              </svg>
              Save participants
            </button>
          </div>
        </footer>
      </main>
    );
  }

  renderSourceSchoolModal() {
    const { user } = this.props;
    const { isSourceSchoolModalOpen, sourceSchoolIds } = this.state;

    return (
      <SchoolUnionSelectSchoolForm
        user={user}
        isOpen={Boolean(this.props.recruitingSchoolsPage) || isSourceSchoolModalOpen}
        presentation={this.props.recruitingSchoolsPage ? 'page' : 'modal'}
        onDirtyChange={this.onSourceSchoolsDirtyChange}
        onClose={this.closeSourceSchoolModal}
        isMultiSelect
        selectedSchoolIds={sourceSchoolIds}
        onContinueMultiple={this.onSourceSchoolsSelected}
        title="Choose recruiting schools"
        description="Choose the member schools whose students should be available on the left. You can change this list later without removing anyone already in the team."
        continueText="Use selected schools"
      />
    );
  }

  openSourceSchoolModal = () => {
    this.openRecruitmentPage('schools');
  };

  closeSourceSchoolModal = () => {
    if (this.props.recruitingSchoolsPage) this.openRecruitmentPage('edit');
    else this.setState({ isSourceSchoolModalOpen: false });
  };

  onSourceSchoolsDirtyChange = (dirty: boolean) => {
    this.sourceSchoolsDirty = dirty;
    if (this.hasUnsavedChanges()) window.addEventListener('beforeunload', this.onBeforeUnload);
    else window.removeEventListener('beforeunload', this.onBeforeUnload);
  };

  openRecruitmentPage = (page: 'schools' | 'recruit' | 'edit') => {
    this.props.history.push({pathname: `/highLevelTournaments/teams/${page}`, search: `tournamentId=${this.getTournamentId()}&teamId=${this.getTeamId()}`, state: this.props.location.state});
  };

  onSourceSchoolsSelected = (sourceSchoolIds: string[]) => {
    const allowedIds = new Set(this.state.availableSchools.map(school => String(school.id || school._id || '')));
    const normalizedIds = Array.from(new Set(sourceSchoolIds.map(String).filter(id => id && allowedIds.has(id))));
    if (normalizedIds.length === 0) return;
    this.sourceSchoolsDirty = false;

    this.setState(
      prev => ({
        sourceSchoolIds: normalizedIds,
        isSourceSchoolModalOpen: false,
        itemsSearch: '',
        itemsFilters: { ...prev.itemsFilters, schools: [] },
        itemCurrentPage: 1,
        itemsSelected: [],
        isSelectAllItemsChecked: false
      }),
      () => {this.loadEligibleStudents(1); if (this.props.recruitingSchoolsPage) this.openRecruitmentPage('edit');}
    );
  };
}
